import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type MerchantOrderForm = PaginationParameters<{
  type?: string;
  cache?: string;
  min_sum?: number;
  max_sum?: number;
  status?: string;
  date_start?: number;
  date_end?: number;
  invid?: string;
}>;

export type MerchantOrder = {
  appeal?: string;
  cache: string;
  bank: string;
  created_at: string;
  ern_rub: number;
  ern_usdt: number;
  exchange_rate: number;
  id: string;
  invid: string;
  merchant_amount: number;
  merchant_amount_usdt: number;
  message: string;
  method: string;
  order_final_amount: number;
  order_final_amount_usdt: number;
  order_start_amount: number;
  order_start_amount_usdt: number;
  requisite: string;
  status: MerchantOrderStatus;
  type: MerchantOrderType;
};

export enum MerchantOrderStatus {
  Completed = "completed",
  Canceled = "canceled",
  Pending = "pending",
  Processing = "processing",
  DisputeOpen = "dispute_open",
}

export enum MerchantOrderType {
  PayIn = "pay_in",
  PayOut = "pay_out",
}

export type MerchantOrderResponse<T = MerchantOrder> = PaginationResponse<{
  orders: T[];
}>;

export const getMerchantOrdersApi = async <T = MerchantOrder>(
  userId: string,
  data?: MerchantOrderForm
) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<MerchantOrderResponse<T>>({
      url: `api/v1/merchant/${userId}/orders?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("Orders failed:", error);
    throw error;
  }
};
